import { Loader2 } from "lucide-react";
import { MAP_LAYERS, layerLabel, type MapLayer } from "@/lib/map/search-params";

/**
 * Four ways of reading the same map. A button group rather than tabs: these switch
 * what one region renders, they don't reveal separate panels, and aria-pressed says
 * exactly that. 44px tall so it is thumb-usable.
 */
export function MapLayerSwitcher({
  value,
  onChange,
  loading,
}: {
  value: MapLayer;
  onChange: (layer: MapLayer) => void;
  loading?: boolean;
}) {
  return (
    <div className="flex items-end gap-x-4 border-b border-border">
      <span aria-hidden className="label-caps hidden pb-3 text-muted-foreground sm:inline">
        Show
      </span>
      <div
        role="group"
        aria-label="Choose what the map shows"
        className="-mb-px flex min-w-0 gap-x-5 overflow-x-auto [scrollbar-width:none]"
      >
        {MAP_LAYERS.map((id) => {
          const active = id === value;
          return (
            <button
              key={id}
              type="button"
              aria-pressed={active}
              onClick={() => onChange(id)}
              className={`min-h-11 shrink-0 whitespace-nowrap border-b-2 text-[0.9375rem] transition-surface ${
                active
                  ? "border-rust font-semibold text-foreground"
                  : "border-transparent text-muted-foreground hover:text-foreground"
              }`}
            >
              {layerLabel[id]}
            </button>
          );
        })}
      </div>
      {loading && (
        <p role="status" className="flex items-center gap-1.5 pb-3 text-xs text-muted-foreground">
          <Loader2 className="h-3.5 w-3.5 animate-spin" aria-hidden /> Loading species ranges…
        </p>
      )}
    </div>
  );
}
